import { useMutation } from '@tanstack/react-query';
import useSlingApi from '@sdk/api/useSlingApi';
import { ConversationBasic, CreateConversationPayload } from '@sdk/messages/types/apiTypes';

import { useConversationQueryCache } from '@web/conversations/hooks/useConversationQueryCache';
import { mapAPIConversationBasicToUI } from '@web/conversations/utils/mappers';

import { useSoundNotification } from './useSoundNotification';

export const useCreateConversation = () => {
  const { addConversations } = useConversationQueryCache();
  const { conversation } = useSlingApi();
  const { messageSent } = useSoundNotification();

  const mutation = useMutation({
    mutationFn: async (payload: CreateConversationPayload) => {
      messageSent();
      const result = await conversation.add(payload);
      let conversationResponse: ConversationBasic;

      if (Array.isArray(result.data)) {
        // if multiple conversation exist, take the most recent one
        conversationResponse = result.data.sort((a, b) => b.lastwriteId - a.lastwriteId)[0];
      } else {
        conversationResponse = result.data;
      }
      const mappedConversation = mapAPIConversationBasicToUI(conversationResponse);

      addConversations(mappedConversation);

      return mappedConversation;
    },
  });

  return mutation;
};
